import { IconMessage16 } from '@cian/ui-kit';

import { FC, JSX } from 'react';

import { NarrowCardMoreControlsItem } from '../MoreItemComplaint';

import { ChatButtonContainer } from './ChatButtonContainer';

export const ChatButtonNarrowCard: FC = () => {
  return (
    <ChatButtonContainer>
      {({ onClick }): JSX.Element => (
        <NarrowCardMoreControlsItem icon={<IconMessage16 />} title="Написать" onClick={onClick} />
      )}
    </ChatButtonContainer>
  );
};
